import { useCallback } from 'react';

import type { AdvancedSearchResultInteractedMetadata } from '../../../common/utils/events/advanced-search-result-interacted';
import {
	onSummarizeInChatButtonClicked,
	type SummarizeInChatButtonClickedArgs,
} from '../../../common/utils/events/summarize-in-chat-button-clicked';
import { getExtensionData } from '../../../common/utils/relay/get-extension-data';
import { useAnalytics, useCommonAndPrivateAttributes } from '../../analytics';

interface FireSummarizeInChatButtonClickedProps {
	location: SummarizeInChatButtonClickedArgs['location'];
	metadata: AdvancedSearchResultInteractedMetadata;
	position?: number;
}
/**
 * @returns a callback to fire an event when the result
 * is clicked by the user.
 */
export const useFireSummarizeInChatButtonClicked: ({
	location,
	metadata,
	position,
}: FireSummarizeInChatButtonClickedProps) => () => void = ({
	location,
	metadata,
	position,
}: FireSummarizeInChatButtonClickedProps) => {
	const { fireAnalyticsEvent } = useAnalytics();
	const { commonAttributes, nonPrivacySafeAttributes } = useCommonAndPrivateAttributes();

	return useCallback(() => {
		fireAnalyticsEvent(
			onSummarizeInChatButtonClicked({
				commonAttributes: {
					...commonAttributes,
					...getExtensionData(commonAttributes.isCQL),
				},
				nonPrivacySafeAttributes,
				location,
				metadata,
				position,
			}),
		);
	}, [
		fireAnalyticsEvent,
		commonAttributes,
		nonPrivacySafeAttributes,
		location,
		metadata,
		position,
	]);
};
